import React, { useMemo, useRef } from 'react';

import { useVirtualizer } from '@tanstack/react-virtual';
import { orderBy } from 'lodash';

import { QueryResponse } from 'api/queries/prioritiesMatrixCards.query';

import classes from 'components/widgets/PrioritiesMatrix/components/Cards/components/CardList/CardList.module.scss';
import { CardItem } from 'components/widgets/PrioritiesMatrix/components/Cards/components/CardList/components/CardItem/CardItem';

export const CardList = ({ filteredCardsData }: { filteredCardsData: QueryResponse[] }) => {
    const parentRef = useRef<HTMLDivElement>(null);

    const cards = useMemo(
        () => orderBy(filteredCardsData, ['rank', 'criticalityScore'], ['asc', 'desc']),
        [filteredCardsData],
    );

    const virtualizer = useVirtualizer({
        count: cards.length,
        getScrollElement: () => parentRef.current,
        estimateSize: () => 260,
        overscan: 0,
    });

    const items = virtualizer.getVirtualItems();

    return (
        <div
            ref={parentRef}
            style={{
                width: `100%`,
                height: `100%`,
                contain: 'strict',
            }}
            className={classes.variableSizeList}
        >
            <div
                style={{
                    height: virtualizer.getTotalSize(),
                    width: '100%',
                    position: 'relative',
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        transform: `translateY(${items.length > 0 ? items[0].start : 0}px)`,
                    }}
                >
                    {items.map((virtualRow) => (
                        <div key={virtualRow.key} data-index={virtualRow.index} ref={virtualizer.measureElement}>
                            <CardItem card={cards[virtualRow.index]} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
